<template>
  <div class="recharge-record">
    <pageHeader title="充值记录">
      <template v-slot:headerRight>
        <!-- <div class="icon-item" @click="rechargeDel">
          <img src="@/assets/images/ic_delete_seven.png" alt="" />
          <span>删除</span>
        </div> -->
        <div class="icon-item" @click="customerDialogVirsble = true">
          <img src="@/assets/images/ic_customer_one.png" alt="" />
          <span>客服</span>
        </div>
      </template>
    </pageHeader>

    <div class="container">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="暂无更多数据"
        @load="onLoad"
      >
        <van-swipe-cell v-for="(item, i) in rechargeList" :key="i">
          <div class="recharge-item">
            <div class="recharge-item-game-info-and-status">
              <div class="recharge-item-game-info">
                <img :src="item.logoUrl" alt="" />
                <div class="game-info">
                  <h1>{{ item.gameName }}</h1>
                  <span>游戏账号：{{ item.gameAccount }}</span>
                </div>
              </div>
              <div class="recharge-item-status">
                <h1 :code="rechargeStatusMaps(item.rechargeStatus)">{{ item.rechargeStatus }}</h1>
                <span>{{ item.createTime }}</span>
              </div>
            </div>
            <div class="paltform-and-recharge-amount">
              <div class="plftform-info">
                <img :src="item.channelLogoUrl" alt="" />
                <span>{{ item.channelName }}</span>
              </div>
              <div class="recharge-amount">
                <span>(实付¥{{ item.realMoney }})</span>
                <span>¥ {{ item.amount }}</span>
              </div>
            </div>
            <div class="recharge-again">
              <div
                class="recharge-tips"
                v-if="item.rechargeStatus == '充值失败' && item.type == 1"
              >
                <img src="@/assets/images/error-tip.png" alt="" />
                <span>首充审核，请联系客服</span>
              </div>
              <!-- 占位 -->
              <div v-else class="recharge-other-tips">
                <span v-if="item.couponAmount > 0"
                  >优惠券抵扣：{{ item.couponAmount }}</span
                >
                <span v-if="userInfo.vipLevel >= 3 && item.score && item.score != 0"
                  >积分 <em class="point">+{{ item.score }}</em></span
                >
              </div>

              <div class="recharge-btns">
                <span
                  v-if="item.rechargeStatus == '等待支付'"
                  @click="showDialog(item)"
                  >取消订单</span
                >
                <div class="recharge-btn" @click="rechargeAgain(item)">再次充值</div>
              </div>
            </div>
          </div>
          <template #right>
            <!-- <van-button square text="删除" type="danger" class="delete-button" /> -->
            <div class="delete-button">
              <img src="@/assets/images/delete.png" alt="" />
              <span>删除</span>
            </div>
          </template>
        </van-swipe-cell>
      </van-list>
    </div>

    <customerDialog
      v-if="customerDialogVirsble"
      v-model="customerDialogVirsble"
      @handleClose="dialogClose"
    />

    <div class="prize-draw" @click="drawPrizeDialogVisible = true" v-if="userInfo && userInfo.vipLevel >= 3">
      <img src="@/assets/images/ic_draw_1.png" alt="" />
      <div class="prize-draw-desc">剩余抽奖:{{ totalPrizeNum }}次</div>
    </div>

    <drawPrizeDialog 
      v-if="drawPrizeDialogVisible"
      v-model="drawPrizeDialogVisible"
      @priseChange="getDrawScoreRecordList"
    />
  </div>
</template>

<script>
import pageHeader from "@/components/PageHeader";
import drawPrizeDialog from "@/components/DrawPrizeDialog";
import customerDialog from "@/components/CustomerDialog";
import { requestMethods } from "@m/api";
import { mapGetters } from "vuex";
export default {
  components: {
    pageHeader,
    customerDialog,
    drawPrizeDialog
  },
  data() {
    return {
      rechargeList: [],
      loading: false,
      finished: false,
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      choseInfo: {},
      customerDialogVirsble: false,
      totalPrizeNum: 0,
      prizeDrawList: [],
      drawPrizeDialogVisible: false,
      
    };
  },
  computed: {
    ...mapGetters(["uuid", "userInfo"]),
  },
  mounted() {
    this.getRechargeeList();
    if(this.userInfo.vipLevel >= 3) {
      this.getDrawScoreRecordList()
    }
  },
  methods: {
    dialogClose(action, done) {
      done();
    },

    rechargeStatusMaps(val) {
      const maps = {
        '充值成功': '01',
        '充值失败': '02'
      }
      return maps[val]
    },

    resetList() {
      this.currentPage = 1; // 重置页码为第一页
      this.finished = false; // 重置 finished 状态
      this.rechargeList = []; // 清空当前列表
      this.totalCount = 0;
    },

    async onLoad() {
      this.loading = true;
      const { data, totalCount } = await this.getRechargeeList();

      this.rechargeList = [...this.rechargeList, ...data];
      this.totalCount = totalCount;
      this.totalPage = Math.ceil(this.totalCount / this.pageSize);
      // 数据全部加载完成
      if (this.currentPage >= this.totalPage) {
        this.finished = true;
      }
      this.currentPage += 1;

      this.loading = false;
    },
    /**
     * 查询充值记录
     */
    async getRechargeeList() {
      try {
        const { data, totalCount } = await requestMethods(
          "/modules/RechargeAction/getRechargeList.htm",
          "post",
          {
            uuid: this.uuid,
            appType: "WM",
            currentPage: this.currentPage,
            pageSize: this.pageSize,
          }
        );
        return {
          data: data,
          totalCount: totalCount,
        };
      } catch (error) {
        this.$toast({
          message: error.message,
          position: "bottom",
        });
      }
    },

    beforeClose(action, done) {
      if (action === "confirm") {
        this.cancelRecharge(this.choseInfo);
        done();
      } else {
        done();
      }
    },

    showDialog(info) {
      this.choseInfo = info;
      this.$dialog.confirm({
        title: "温馨提示",
        message: "您确定取消订单吗？取消后，优惠券将立即退回！",
        confirmButtonColor: "#FF7A3E",
        beforeClose: this.beforeClose,
      });
    },
    /**
     * 取消订单
     */
    async cancelRecharge(info) {
      try {
        await requestMethods(
          "/modules/RechargeAction/cancelRecharge.htm",
          "post",
          {
            uuid: this.uuid,
            appType: "WM",
            rechargeId: info.id,
          }
        );
        this.$toast({
          message: "取消成功",
          position: "bottom",
        });
        this.getRechargeeList();
      } catch (error) {
        this.$toast({
          message: error.message,
          position: "bottom",
        });
      }
    },

    /**
     * 删除全部记录
     */
    rechargeDel() {},

    /**
     * 再次充值
     */
    rechargeAgain(info) {
      const {
        logoUrl,
        gameName,
        gameId,
        discount,
        channelName,
        channelLogoUrl,
        id,
        gameAccount
      } = info;
      this.$router.push({
        path: "/recharge",
        query: {
          logoUrl,
          gameName,
          gameId,
          discount,
          platName: channelName,
          platUrl: channelLogoUrl,
          rechargeGameId: id,
          gameAccountNo: gameAccount
        },
      });
    },

    /**
     * 获取抽奖次数
     */
    async getDrawScoreRecordList() {
      try {
        const { data, totalCount } = await requestMethods(
          "/modules/drawscore/drawScoreRecord/getDrawScoreRecordList.htm",
          "post",
          {
            searchParams: JSON.stringify({
              uuid: this.uuid,
              appType: "WM",
            }),
            pageSize: 999,
            currentPage: 1
          }
        );
        this.prizeDrawList = data || []
        this.totalPrizeNum = totalCount
      } catch (error) {
        this.$toast({
          message: error.message,
          position: "bottom",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.recharge-record {
  min-height: 100vh;
  background: #f5f5f5;
  position: relative;

  .prize-draw {
    position: fixed;
    bottom: 95px;
    left: 32px;

    img {
      width: 200px;
      height: 200px;
    }
    .prize-draw-desc {
      width: 200px;
      height: 44px;
      background: #ffba00;
      border-radius: 22px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 24px;
      color: #ffffff;
      line-height: 44px;
      text-align: center;
      position: absolute;
      bottom: 10px;
    }
  }

  .page-right {
    display: flex;
    align-items: center;

    .icon-item {
      display: flex;
      align-items: flex-end;
      margin-right: 8px;

      img {
        width: 30px;
        height: 30px;
        margin-right: 6px;
      }
      span {
        color: #8f8f8f;
      }
    }
  }
  .container {
    .recharge-item {
      width: 100%;
      padding: 40px 30px 30px 30px;
      // height: 200px;
      background: #fff;
      margin-top: 20px;

      .recharge-item-game-info-and-status {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #e6e6e6;
        padding-bottom: 27px;

        .recharge-item-game-info {
          display: flex;
          align-items: center;

          img {
            width: 90px;
            height: 90px;
            margin-right: 20px;
          }
          .game-info {
            h1 {
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 28px;
              color: #212121;
              line-height: 40px;
              margin-bottom: 12px;
            }
            span {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 28px;
              color: #414141;
              line-height: 40px;
            }
          }
        }
        .recharge-item-status {
          text-align: right;
          h1 {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 28px;
            color: #000000;
            line-height: 40px;
            margin-bottom: 12px;

            &[code='01'] {
              color: #ff7a3e;
            }
             &[code='02'] {
              color: #e02020;
            }
          }
          span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 26px;
            color: #bbbbbb;
            line-height: 37px;
          }
        }
      }

      .paltform-and-recharge-amount {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 30px;

        .plftform-info {
          display: flex;
          align-items: center;

          img {
            width: 60px;
            height: 60px;
            margin-right: 10px;
          }
          span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 26px;
            color: #666666;
            line-height: 37px;
          }
        }
        .recharge-amount {
          display: flex;
          align-items: center;
          span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 26px;
            color: #666666;
            line-height: 37px;

            &:last-child {
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 40px;
              color: #ff7a3e;
              line-height: 56px;
              margin-left: 10px;
            }
          }
        }
      }

      .recharge-again {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 10px;

        .recharge-tips {
          display: flex;
          align-items: center;
          margin-left: 10px;

          img {
            width: 30px;
            height: 30px;
            margin-right: 16px;
          }
          span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 26px;
            color: #e02020;
            line-height: 37px;
          }
        }

        .recharge-other-tips {
          display: flex;
          align-items: center;
          margin-left: 10px;

          span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 26px;
            color: #8f8f8f;
            line-height: 37px;
          }

          .point {
            text-decoration-line: underline;
          }
        }

        .recharge-btns {
          display: flex;
          align-items: center;

          span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 26px;
            color: #bbbbbb;
          }

          .recharge-btn {
            width: 170px;
            height: 60px;
            background: #ff7a3e;
            border-radius: 30px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 28px;
            color: #ffffff;
            text-align: center;
            line-height: 60px;
            margin-left: 12px;
          }
        }
      }
    }
    .delete-button {
      padding: 130px 0;
      text-align: center;
      height: 100%;
      width: 150px;
      img {
        width: 36px;
        height: 33.5px;
      }
      span {
        display: block;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 28px;
        color: #999999;
        line-height: 40px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/rechargeRecord/index.vue